import * as React from "react";
const SvgFiRrBlender = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m19.187 17.18 2.772-13.687A2.997 2.997 0 0 0 18.999 0H5.5A4.505 4.505 0 0 0 1 4.5v6C1 12.981 3.019 15 5.5 15H6v2.127A4.01 4.01 0 0 0 3 21c0 1.654 1.346 3 3 3h13c1.654 0 3-1.346 3-3a4.005 4.005 0 0 0-2.813-3.82M5.5 13A2.503 2.503 0 0 1 3 10.5v-6C3 3.122 4.122 2 5.5 2H6v11zm4.5 0H8v-2h2a1 1 0 0 0 0-2H8V7h2a1 1 0 0 0 0-2H8V2h10.999c.299 0 .57.125.764.354a.97.97 0 0 1 .229.776L17.182 17H8v-2h2a1 1 0 0 0 0-2m9 9H6c-.551 0-1-.449-1-1 0-1.103.897-2 2-2h11c1.103 0 2 .897 2 2 0 .551-.448 1-1 1"
    />
  </svg>
);
export default SvgFiRrBlender;
